import { atom } from "jotai";
import { GravitySample } from "../types/interfaces";

export interface DeviceMotionState {
  supported: boolean;
  permitted: boolean;
  motionEvents: boolean;
  stationary: boolean;
  gravityString: string;
  gravityBuffer: GravitySample[];
  isChecked: boolean;
  isDenied: boolean;
}

export const deviceMotionAtom = atom<DeviceMotionState>({
  supported: true,
  permitted: false,
  motionEvents: true,
  stationary: false,
  gravityString: "",
  gravityBuffer: [],
  isChecked: false,
  isDenied: false,
});
